import { ref, computed, type Ref } from 'vue';

type CommonObject = Record<string, unknown>;
type UseDraftStateProps<T> = {
  initialDraft?: T;
  getDerivedDraft?: (draft: T) => T;
};

export function useDraftState<T extends CommonObject>({
  initialDraft = {} as T,
  getDerivedDraft = (draft: T) => draft,
}: UseDraftStateProps<T> = {}) {
  /**
   * Workaround for Ref with generic
   * @see https://github.com/vuejs/core/issues/2136
   */
  const state = ref(initialDraft || {}) as Ref<T>;
  const derivedDraft = computed(() => getDerivedDraft(state.value));

  function updateDraft<T extends CommonObject>(updates: Partial<T>) {
    state.value = {
      ...state.value,
      ...updates,
    };
  }

  function resetDraft() {
    state.value = initialDraft;
  }

  return {
    state,
    derivedDraft,
    updateDraft,
    resetDraft,
  };
}
